module.exports = __webpack_public_path__ + "static/media/pressures.9694e158.PNG";